enum PAUSE_SUBREASON {
  dog_passed = 'DOG_PASSED'
}

export { PAUSE_SUBREASON }
